<template>
    <div class="modal">
        <div class="popup">
            <div class="popup-title">{{ text }}</div>
            <div class="popup-text">
                <button class="btn-action"
                        @click="$emit('close')">Понятно</button>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: "message",
        props: ["text"]
    }
</script>